//故障返修申请表格
<template>
  <el-table border :data="tableData" height="100%">
    <el-table-column align="center" label="序号" type="index" width="60" />
    <el-table-column
      header-align="center"
      align="center"
      show-overflow-tooltip
      prop="orderCode"
      label="申请单号"
      width="180"
    />
    <el-table-column
      header-align="center"
      align="center"
      show-overflow-tooltip
      prop="proposerName"
      label="申请人"
      width="100"
    />
    <el-table-column
      header-align="center"
      align="center"
      show-overflow-tooltip
      prop="applyDepartmentName"
      label="申请人部门"
      width="100"
    />
    <el-table-column
      header-align="center"
      align="center"
      show-overflow-tooltip
      label="日期"
      width="120"
    >
      <template slot-scope="{ row }">
        {{ row.applyTime | date('YYYY-mm-dd') }}
      </template>
    </el-table-column>
    <el-table-column
      header-align="center"
      align="center"
      show-overflow-tooltip
      label="客户名称"
      :formatter="({ clientName }) => clientName || '-'"
    />
    <el-table-column
      header-align="center"
      align="center"
      show-overflow-tooltip
      prop="consigner"
      label="发货人"
    />
    <el-table-column
      header-align="center"
      align="center"
      show-overflow-tooltip
      prop="consignerMobile"
      label="发货人联系方式"
      width="120"
    />
    <el-table-column
      header-align="center"
      align="center"
      show-overflow-tooltip
      prop="trackingNumber"
      label="物流单号"
      width="120"
    />
    <el-table-column
      header-align="center"
      align="center"
      show-overflow-tooltip
      prop="consignee"
      label="收货人"
    />
    <el-table-column
      header-align="center"
      align="center"
      show-overflow-tooltip
      prop="consigneeMobile"
      label="联系电话"
      width="120"
    />
    <el-table-column
      header-align="center"
      align="center"
      show-overflow-tooltip
      prop="code"
      label="设备料号"
      width="120"
    />
    <el-table-column
      header-align="center"
      align="center"
      show-overflow-tooltip
      prop="name"
      label="设备名称"
      width="120"
    />
	<el-table-column
	  header-align="center"
	  align="center"
	  show-overflow-tooltip
	  prop="num"
	  label="数量"
	  width="80"
	/>
    <el-table-column
      header-align="center"
      align="center"
      show-overflow-tooltip
      label="设备sn"
      width="120"
      :formatter="({ sn }) => sn || '-'"
    />
    <el-table-column
      header-align="center"
      align="center"
      show-overflow-tooltip
      prop="detail"
      label="故障详情"
      :formatter="({ detail }) => detail || '-'"
      width="120"
    />
    <el-table-column
      header-align="center"
      align="center"
      show-overflow-tooltip
      prop="auditStatusStr"
      label="审批状态"
    />
    <el-table-column
      header-align="center"
      label="操作"
      width="60"
      fixed="right"
    >
      <template slot-scope="{ row }">
        <el-button
          size="medium"
          type="text"
          @click="toDetail({ ...row, orderType: 0 })"
        >
          详情
        </el-button>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import tableTypeMixins from './tableTypeMixins.js'
export default {
  mixins: [tableTypeMixins]
}
</script>

<style lang="scss" scoped></style>
